import React from "react";

export default function MakePaymentShimmer() {
  return (
    <div tw="flex flex-col gap-[24px] w-full h-full">
      <div tw="animate-pulse flex items-center justify-between p-[16px] h-[74px] w-full rounded-[16px] bg-containment-tertiary">
        <div tw="flex items-center">
          <div tw="animate-pulse h-[40px] w-[40px] rounded-full bg-containment-primary"></div>
          <div>
            <div tw="animate-pulse h-[16px] w-[75px] rounded-[999px] bg-containment-primary mb-[2px]"></div>
            <div tw="animate-pulse h-[24px] w-[250px] rounded-[999px] bg-containment-primary"></div>
          </div>
        </div>
        <div tw="animate-pulse h-[24px] w-[24px] rounded-full bg-containment-primary"></div>
      </div>

      <div tw="animate-pulse flex items-center justify-between p-[30px] w-full rounded-[16px] bg-containment-tertiary flex items-center justify-center">
        <div tw="animate-pulse h-[180px] w-[180px] rounded-[16px] bg-containment-primary"></div>
      </div>

      <div tw="animate-pulse p-[16px] flex flex-col gap-[20px] w-full rounded-[16px] bg-containment-tertiary">
        <div tw="flex items-center justify-between w-full">
          <div>
            <div tw="animate-pulse h-[16px] w-[75px] rounded-[999px] bg-containment-primary mb-[2px]"></div>
            <div tw="animate-pulse h-[24px] w-[254px] rounded-[999px] bg-containment-primary"></div>
          </div>
          <div tw="animate-pulse h-[24px] w-[24px] rounded-full bg-containment-primary"></div>
        </div>

        <div tw="flex items-center justify-between">
          <div tw="animate-pulse h-[20px] w-[74px] rounded-[999px] bg-containment-primary "></div>
          <div tw="animate-pulse h-[20px] w-[124px] rounded-[999px] bg-containment-primary"></div>
        </div>

        <div tw="flex items-center justify-between">
          <div tw="animate-pulse h-[20px] w-[124px] rounded-[999px] bg-containment-primary "></div>
          <div tw="animate-pulse h-[20px] w-[124px] rounded-[999px] bg-containment-primary "></div>
        </div>
      </div>

      <div tw="animate-pulse h-[58px] w-full rounded-[999px] bg-containment-tertiary mt-auto"></div>
    </div>
  );
}
